import { InjectionToken } from '@angular/core';

export interface PersistencyModuleConfig {
  apiBaseUrl: string;
  mapboxAccessToken: string;
}

/**
 * Host-supplied API config, consumed by every `src/api/` service.
 *
 * It lives here rather than next to `FormsEngineModule` on purpose: that file
 * imports all four dashboards, so a service reaching for the token through it
 * would pull the whole component tree back into the services layer and close an
 * import cycle (`provideCompiling` → api service → module → dashboards →
 * envelope-b → the services it provides).
 */
export const PERSISTENCY_MODULE_CONFIG =
  new InjectionToken<PersistencyModuleConfig>('persistencyModuleConfig');
